import { createBrowserRouter } from "react-router-dom";

import {
  MainPage,
  MainLayout,
  ErrorPage,
} from "./pages";
import {
  PinPage,
  OtpPage,
  LoginPage,
  B2pOtpPage,
  LoadingPage,
  PassportPage,
  LoginPageLayout,
} from "./pages/Login";
import {
  CardsPage,
  AddSbpPaymentPage,
  AddCardPaymentPage,
  AddPaymentErrorPage,
  AddPaymentSuccessPage,
} from "./pages/Cards";
import {
  SbpTransferPage,
  SbpTransferBanksPage,
  SbpTransferProcessingPage,
  SbpTransferResultPage,
} from "./pages/SbpTransfer";
import { CoolingPage } from "./pages/Cooling";
import { OperationsPage } from "./pages/Operations";
import { DocumentsPage, ProfilePage } from "./pages/Profile";
import { PaymentsSchedulePage } from "./pages/PaymentsSchedule";

import { YMPageTracker } from "./components/features/YMPageTracker";
import { LimitReject, LimitSuccess } from "./components/features/LoginPage";
// import { QrPage, QrPaymentPage, } from "./pages/QR";

export const RoutesMap = {
  index: "/",
  profile: "/profile",
  documents: "/profile/documents",
  cooling: "/cooling",
  operations: "/operations",
  paymentsSchedule: "/payments-schedule",

  // qr: {
  //   index: "/qr",
  //   payment: "/qr/payment",
  // },
  sbpTransfer: {
    index: "/sbp-transfer",
    banks: "/sbp-transfer/banks",
    processing: "/sbp-transfer/processing",
    result: "/sbp-transfer/result",
  },
  cards: {
    index: "/cards",
    addCard: "/cards/add-card",
    addSbp: "/cards/add-sbp",
    // redirect from SBC
    addSuccess: "/cards/add-result-success",
    addError: "/cards/add-result-error",
  },
  login: {
    index: "/login",
    otp: "/login/otp",
    passport: "/login/passport",
    pin: "/login/pin",
    // limits
    loading: "/login/waiting",
    limitSuccess: "/login/limit-success",
    limitReject: "/login/limit-reject",
    // b2p
    otpB2p: "/login/b2p-otp",
  },

} as const;

export const routes = () => createBrowserRouter([{
  path: "/",
  element: (
    <>
      <YMPageTracker />
      <MainLayout />
    </>
  ),
  loader: MainLayout.loader,
  errorElement: <ErrorPage />,
  children: [
    { path: RoutesMap.index, element: <MainPage /> },
    { path: RoutesMap.profile, element: <ProfilePage /> },
    { path: RoutesMap.documents, element: <DocumentsPage /> },
    { path: RoutesMap.cooling, element: <CoolingPage /> },
    { path: RoutesMap.operations, element: <OperationsPage /> },
    { path: RoutesMap.paymentsSchedule, element: <PaymentsSchedulePage /> },

    // { path: RoutesMap.qr.index,
    //   children: [
    //     { path: RoutesMap.qr.index, element: <QrPage />, },
    //     { path: RoutesMap.qr.payment, element: <QrPaymentPage />, },
    //   ],
    // },

    { path: RoutesMap.sbpTransfer.index,
      children: [
        { path: RoutesMap.sbpTransfer.index, element: <SbpTransferPage /> },
        { path: RoutesMap.sbpTransfer.banks, element: <SbpTransferBanksPage />, loader: SbpTransferBanksPage.loader },
        { path: RoutesMap.sbpTransfer.processing, element: <SbpTransferProcessingPage />, loader: SbpTransferProcessingPage.loader },
        { path: RoutesMap.sbpTransfer.result, element: <SbpTransferResultPage />, loader: SbpTransferResultPage.loader },
      ],
    },

    { path: RoutesMap.cards.index,
      children: [
        { path: RoutesMap.cards.index, element: <CardsPage /> },
        { path: RoutesMap.cards.addCard, element: <AddCardPaymentPage /> },
        { path: RoutesMap.cards.addSbp, element: <AddSbpPaymentPage /> },
        { path: RoutesMap.cards.addSuccess, element: <AddPaymentSuccessPage /> },
        { path: RoutesMap.cards.addError, element: <AddPaymentErrorPage /> },
      ],
    },

    { path: RoutesMap.login.index,
      element: <LoginPageLayout />,
      children: [
        { path: RoutesMap.login.index, element: <LoginPage />, loader: LoginPage.loader },
        { path: RoutesMap.login.otp, element: <OtpPage />, loader: OtpPage.loader },
        { path: RoutesMap.login.passport, element: <PassportPage />, loader: PassportPage.loader },
        { path: RoutesMap.login.pin, element: <PinPage />, loader: PinPage.loader },
        { path: RoutesMap.login.loading, element: <LoadingPage />, loader: LoadingPage.loader },
        { path: RoutesMap.login.limitSuccess, element: <LimitSuccess />, loader: LimitSuccess.loader },
        { path: RoutesMap.login.limitReject, element: <LimitReject /> },
        { path: RoutesMap.login.otpB2p, element: <B2pOtpPage />, loader: B2pOtpPage.loader },
      ],
    },
  ],
}]);
